import i18next from 'i18next';
export { default as i18next } from 'i18next';
import merge from 'lodash.merge';
import axios from 'axios';
import qs from 'qs';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

/**
 * Class that exposes the app configuration
 */
var Config = /** @class */ (function () {
    function Config() {
    }
    Config.set = function (config) {
        Object.assign(this, config);
    };
    Config.datasourceLimit = 10;
    Config.dateFormat = 'YYYY-MM-DD';
    Config.displayFormat = 'YYYY-MM-DD';
    Config.endPoint = '';
    Config.env = {};
    Config.homeUrl = '';
    Config.language = 'en-US';
    Config.metadataEndPoint = '';
    Config.mode = 'development';
    Config.title = '';
    return Config;
}());

// tslint:disable: no-console
var DEVELOPMENT_MODE = 'development';
/**
 * Class to log messages
 */
var Logger = /** @class */ (function () {
    function Logger() {
    }
    Logger.warn = function (message) {
        if (Config.mode === DEVELOPMENT_MODE) {
            console.warn(message);
        }
    };
    return Logger;
}());

/**
 * Class that encapsulate a router defined by user
 */
var Router = /** @class */ (function () {
    function Router() {
    }
    Router.setInstance = function (instance) {
        this.instance = instance;
    };
    Router.callInstanceMethod = function (method, args) {
        var _a;
        if (args === void 0) { args = []; }
        return (this.instance ? (_a = this.instance)[method].apply(_a, args) : Logger.warn('Router instance not defined'));
    };
    Router.push = function (path, onComplete, onAbort) {
        this.callInstanceMethod('push', [path, onComplete, onAbort]);
    };
    Router.replace = function (path, onComplete, onAbort) {
        this.callInstanceMethod('replace', [path, onComplete, onAbort]);
    };
    Router.back = function () {
        this.callInstanceMethod('back');
    };
    Router.getCurrentRoute = function () {
        return this.callInstanceMethod('getCurrentRoute');
    };
    Router.getPath = function () {
        return this.callInstanceMethod('getPath');
    };
    Router.getHash = function () {
        return this.callInstanceMethod('getHash');
    };
    Router.getQuery = function () {
        return this.callInstanceMethod('getQuery');
    };
    Router.getParams = function () {
        return this.callInstanceMethod('getParams');
    };
    Router.getFullPath = function () {
        return this.callInstanceMethod('getFullPath');
    };
    return Router;
}());

/**
 * Class to manipulate messages to translation
 */
var Messages = /** @class */ (function () {
    function Messages() {
    }
    /**
     * Returns the messages to translation
     */
    Messages.get = function () {
        return this.content;
    };
    /**
     * Adds messages to the content object
     */
    Messages.add = function (newMessages) {
        this.content = merge(this.content, newMessages);
    };
    /**
     * Messages to translation
     */
    Messages.content = {
        'en-US': {
            translation: {
                validationRequired: 'Required',
                validationInvalidEmail: 'Invalid email',
                validationMinimumValue: 'Minimum value: {{limit}}',
                validationMaximumValue: 'Maximum value: {{limit}}',
            },
        },
    };
    return Messages;
}());

/**
 * Class to manipulate the i18next library
 */
var I18n = /** @class */ (function () {
    function I18n() {
    }
    /**
     * Initiates i18next
     */
    I18n.init = function (options) {
        var defaultOptions = {
            lng: window.navigator.language,
            fallbackLng: Config.language,
            resources: Messages.get(),
            keySeparator: '::',
            nsSeparator: ':::',
        };
        var i18nOptions = merge(defaultOptions, options);
        i18next.init(i18nOptions);
    };
    /**
     * Change the i18next language
     */
    I18n.changeLanguage = function (lang) {
        i18next.changeLanguage(lang);
    };
    /**
     * i18next instance
     */
    I18n.instance = i18next;
    return I18n;
}());

/**
 * Class responsible for expose axios http operations
 */
var Http = /** @class */ (function () {
    function Http() {
    }
    Http.get = function (url, config) {
        return axios.get(url, config);
    };
    Http.post = function (url, data, config) {
        return axios.post(url, data, config);
    };
    Http.put = function (url, data, config) {
        return axios.put(url, data, config);
    };
    Http.delete = function (url, config) {
        return axios.delete(url, config);
    };
    Http.setBaseURL = function (baseURL) {
        axios.defaults.baseURL = baseURL;
    };
    return Http;
}());

/**
 * Class used to create interceptors in Axios requests and responses
 */
var Interceptor = /** @class */ (function () {
    function Interceptor() {
    }
    /**
     * Adds a new success request interceptor
     * @param callback Method that will be executed
     * @returns Interceptor id
     */
    Interceptor.addRequestSuccess = function (callback) {
        return axios.interceptors.request.use(callback);
    };
    /**
     * Adds a new fail request interceptor
     * @param callback Method that will be executed
     * @returns Interceptor id
     */
    Interceptor.addRequestFail = function (callback) {
        return axios.interceptors.request.use(undefined, callback);
    };
    /**
     * Adds a new success response interceptor
     * @param callback Method that will be executed
     * @returns Interceptor id
     */
    Interceptor.addResponseSuccess = function (callback) {
        return axios.interceptors.response.use(callback);
    };
    /**
     * Adds a new fail response interceptor
     * @param callback Method that will be executed
     * @returns Interceptor id
     */
    Interceptor.addResponseFail = function (callback) {
        return axios.interceptors.response.use(undefined, callback);
    };
    /**
     * Removes a request interceptor
     * @param id Interceptor id
     */
    Interceptor.removeRequestInterceptor = function (id) {
        axios.interceptors.request.eject(id);
    };
    /**
     * Removes a response interceptor
     * @param id Interceptor id
     */
    Interceptor.removeResponseInterceptor = function (id) {
        axios.interceptors.response.eject(id);
    };
    return Interceptor;
}());

/**
 * Controller not found error
 */
var ControllerNotFoundError = /** @class */ (function () {
    function ControllerNotFoundError(controllerName) {
        this.message = "Controller " + controllerName + " not found";
    }
    return ControllerNotFoundError;
}());

/**
 * Method not found error
 */
var MethodNotFoundError = /** @class */ (function () {
    function MethodNotFoundError(method, controller) {
        this.message = "Method " + method + " not found on controller " + controller;
    }
    return MethodNotFoundError;
}());

/**
 * Instance not found error
 */
var InstanceNotFoundError = /** @class */ (function () {
    function InstanceNotFoundError(instanceName) {
        this.message = "Instance " + instanceName + " not found";
    }
    return InstanceNotFoundError;
}());

/**
 * Invalid Accessor definition
 */
var InvalidAccessorDefinitionError = /** @class */ (function () {
    function InvalidAccessorDefinitionError() {
        this.message = 'Invalid accessor definition';
    }
    return InvalidAccessorDefinitionError;
}());

/**
 * Class that have accessor behavior. An accessor is a reference
 * to a propery or method that exists on a controller. To define an accessor
 * is necessary to use double brackets among it, e.g. {{Controller.property}}.
 */
var Accessor = /** @class */ (function () {
    function Accessor() {
    }
    /**
     * Checks if the value is a valid accessor definition
     * @param value Accessor definition
     */
    Accessor.isAccessorDefinition = function (value) {
        return typeof value === 'string' && value.startsWith('{{') && value.endsWith('}}');
    };
    /**
     * Retrives an array with the first position with controller name and
     * the second position with property or method name
     * @param value Accessor definition
     */
    Accessor.getAccessor = function (value) {
        return value.substring(2, value.length - 2).split('.');
    };
    return Accessor;
}());

/**
 * Loader
 */
var Loader = /** @class */ (function () {
    function Loader() {
    }
    Loader.setControllers = function (controllers) {
        this.controllers = controllers;
        this.clearInstances();
    };
    Loader.getInstance = function (name) {
        var controller = this.controllers[name];
        if (!controller) {
            throw new ControllerNotFoundError(name);
        }
        if (!this.instances[name]) {
            this.instances[name] = new (controller)();
        }
        return this.instances[name];
    };
    Loader.clearInstances = function () {
        var _this = this;
        Object.keys(this.instances).forEach(function (key) {
            if (!_this.instances[key]._singleton) {
                delete _this.instances[key];
            }
        });
    };
    Loader.controllers = {};
    Loader.instances = {};
    return Loader;
}());
/**
 * Singleton decorator
 * When creating a controller using this decorator the controller is not cleared by Loader class
 * @param constructorFunction constructor
 */
// tslint:disable-next-line
function Singleton(constructorFunction) {
    constructorFunction.prototype._singleton = true;
}

/**
 * The MIT License (MIT)
 *
 * Copyright (c) 2016-2019 John Jeremy Leider
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 *
 * Originally copied from Vuetify package
 * (https://github.com/vuetifyjs/vuetify/blob/v1.5.16/packages/vuetify/src/util/mask.ts)
 */
/**
 * Base class control mask on text
 */
var Mask = /** @class */ (function () {
    function Mask() {
    }
    /**
     * Checks is a maks delimiter
     * @param char Mask character
     */
    Mask.isMaskDelimiter = function (char) {
        return char ? new RegExp(this.defaultDelimiters).test(char) : false;
    };
    /**
     * Checks is a valid mask character
     * @param char Mask character
     */
    Mask.isMask = function (char) {
        return this.allowedMasks.hasOwnProperty(char);
    };
    /**
     * Applies mask rules on char value
     * @param mask Mask character
     * @param char Text character
     */
    Mask.convert = function (mask, char) {
        return this.allowedMasks[mask].convert ? this.allowedMasks[mask].convert(char) : char;
    };
    /**
     * Checks is a valid char based on mask types
     * @param mask Mask character
     * @param char Text character
     * @returns Is valid
     */
    Mask.maskValidates = function (mask, char) {
        if (!this.isMask(mask))
            return false;
        return this.allowedMasks[mask].test(char);
    };
    /**
     * Retrieves a value with mask
     * @param text Value to apply mask
     * @param masked Mask pattern
     * @param dontFillMaskBlanks Should keep invalid mask on value
     */
    Mask.getValueWithMask = function (text, masked, dontFillMaskBlanks) {
        if (dontFillMaskBlanks === void 0) { dontFillMaskBlanks = false; }
        var maskCollection = masked;
        var value = text;
        if (value == null)
            value = '';
        if (!masked.length || !value.length)
            return value;
        if (!Array.isArray(masked))
            maskCollection = masked.split('');
        var textIndex = 0;
        var maskIndex = 0;
        var newText = '';
        while (maskIndex < maskCollection.length) {
            var mask = maskCollection[maskIndex];
            // Assign the next character
            var char = value[textIndex];
            // Check if mask is delimiter
            // and current char matches
            if (!this.isMask(mask) && char === mask) {
                newText += mask;
                textIndex += 1;
                // Check if not mask
            }
            else if (!this.isMask(mask) && !dontFillMaskBlanks) {
                newText += mask;
                // Check if is mask and validates
            }
            else if (this.maskValidates(mask, char)) {
                newText += this.convert(mask, char);
                textIndex += 1;
            }
            else {
                return newText;
            }
            maskIndex += 1;
        }
        return newText;
    };
    /**
     * Retrieves a value without mask
     * @param text Value with mask
     */
    Mask.getValueWithoutMask = function (text) {
        return text.replace(new RegExp(this.defaultDelimiters, 'g'), '');
    };
    /**
     * Mask delimiters
     */
    Mask.defaultDelimiters = /[-!$%^&*()_+|~=`{}[\]:";'<>?,./\\ ]/;
    /**
     * Allowed mask patterns
     */
    Mask.allowedMasks = {
        '#': {
            test: function (char) { return (/[0-9]/.test(char)); },
        },
        A: {
            test: function (char) { return (/[A-Z]/i.test(char)); },
            convert: function (char) { return char.toUpperCase(); },
        },
        a: {
            test: function (char) { return (/[a-z]/i.test(char)); },
            convert: function (char) { return char.toLowerCase(); },
        },
        N: {
            test: function (char) { return (/[0-9A-Z]/i.test(char)); },
            convert: function (char) { return char.toUpperCase(); },
        },
        n: {
            test: function (char) { return (/[0-9a-z]/i.test(char)); },
            convert: function (char) { return char.toLowerCase(); },
        },
        X: {
            test: Mask.isMaskDelimiter,
        },
    };
    return Mask;
}());

/**
 * URL util
 */
var URL = /** @class */ (function () {
    function URL() {
    }
    URL.updateQueryString = function (value, replace) {
        if (replace === void 0) { replace = false; }
        var currentQuery = this.getParsedQueryString(this.getFormattedQueryStringFromUrl());
        var query = __assign(__assign({}, currentQuery), value);
        if (replace) {
            Router.replace({ query: query, path: Router.getPath() });
        }
        else {
            Router.push({ query: query, path: Router.getPath() });
        }
    };
    URL.getParsedQueryString = function (value, options) {
        var config = __assign(__assign({}, this.parseOptions), options);
        return qs.parse(value, config);
    };
    URL.getFormattedQueryString = function (obj, options) {
        var config = __assign(__assign({}, this.stringifyOptions), options);
        return qs.stringify(obj, config);
    };
    URL.getParsedQueryStringFromUrl = function () {
        var qsValue = this.getFormattedQueryStringFromUrl();
        return qs.parse(qsValue, this.parseOptions);
    };
    URL.getFormattedQueryStringFromUrl = function () {
        var queryString = Router.getFullPath().split('?');
        if (queryString.length > 1) {
            return queryString[1];
        }
        return '';
    };
    URL.getPropertyAsArray = function (prop) {
        return Array.isArray(prop) ? Array.from(prop) : (prop ? [prop] : []);
    };
    URL.setQueryString = function (query) {
        Router.push({ query: query, path: Router.getPath() });
    };
    URL.replaceQueryString = function (query) {
        Router.replace({ query: query, path: Router.getPath() });
    };
    URL.parseOptions = { allowDots: true, depth: 20 };
    URL.stringifyOptions = { encode: false, allowDots: true, arrayFormat: 'repeat' };
    return URL;
}());

/**
 * Tries to iterate over a value and returns false if iteration is possible, true otherwise.
 * @param value The value to try iterating over.
 * @returns True if no interation is made over the passed value.
 */
var isEmpty = function (value) {
    // tslint:disable-next-line: variable-name
    for (var _entry in value)
        return false;
    return true;
};
/**
 * Validates field not empty
 * @param config Configuration options (message)
 * @returns Rule method
 */
var required = function (config) {
    if (config === void 0) { config = {}; }
    var message = config.message || 'Required';
    return function (value) {
        return value && !isEmpty(value) || typeof value === 'number' || message;
    };
};
/**
 * Validates email format
 * @param config Configuration options (message)
 * @returns Rule method
 */
var email = function (config) {
    if (config === void 0) { config = {}; }
    var message = config.message || 'Invalid email';
    return function (value) {
        var pattern = new RegExp('^[_a-z0-9-]+(\\.[_a-z0-9-]+)*@[a-z0-9-]+(\\.[a-z0-9-]+)*(\\.[a-z]{2,4})$');
        return !(value) || pattern.test(value) || message;
    };
};
var emailPrefix = function (config) {
    if (config === void 0) { config = {}; }
    var message = config.message || 'Invalid email';
    return function (value) {
        var pattern = new RegExp('^[_a-z0-9-]+(\\.[_a-z0-9-]+)*$');
        return !(value) || pattern.test(value) || message;
    };
};
/**
 * Validates field min value
 * @param config Configuration options (limit, message)
 * @returns Rule method
 */
var min = function (config) {
    var limit = config.limit;
    return function (value) {
        return limit <= parseFloat(value) || (config.message || "Minimum value: " + limit);
    };
};
/**
 * Validates field max value
 * @param config Configuration options (limit, message)
 * @returns Rule method
 */
var max = function (config) {
    var limit = config.limit;
    return function (value) {
        return limit >= parseFloat(value) || (config.message || "Maximum value: " + limit);
    };
};
/**
 * All registered validations
 */
var validations = {
    email: email,
    emailPrefix: emailPrefix,
    max: max,
    min: min,
    required: required,
};
/**
 * Used to create validations for fields in JSON
 */
var Validation = /** @class */ (function () {
    function Validation() {
    }
    /**
     * Registers a new validation or overwrites if it exists.
     * All validation methods have an optional configuration parameter and return a method.
     * @param name Validation name
     * @param method Validation method
     */
    Validation.register = function (name, method) {
        validations[name] = method;
    };
    /**
     * Unregisters a validation
     * @param name Validation name
     */
    Validation.unregister = function (name) {
        delete validations[name];
    };
    /**
     * Retrieves a validation
     * @param name Validation name
     * @returns Registered validation
     * @throws Will throw if validation not exists
     */
    Validation.get = function (name) {
        if (validations[name]) {
            return validations[name];
        }
        throw "Validation " + name + " not found";
    };
    /**
     * Retrieves all registered validations
     * @returns All registered validations
     */
    Validation.getAll = function () {
        return validations;
    };
    return Validation;
}());

var appController = 'AppController';
function init(options) {
    if (options === void 0) { options = {}; }
    Config.set(options.config || {});
    Http.setBaseURL(Config.endPoint);
    I18n.init(options.i18n);
    Loader.setControllers(options.controllers || {});
    Router.setInstance(options.router);
    addLanguageInterceptor();
    callInitProjectCallback();
}
function addLanguageInterceptor() {
    Interceptor.addRequestSuccess(function (config) {
        config.headers = __assign(__assign({}, config.headers), { Language: I18n.instance.language });
        return config;
    });
}
function callInitProjectCallback() {
    try {
        var appCtrl = Loader.getInstance(appController);
        if (appCtrl.onInit instanceof Function) {
            appCtrl.onInit();
        }
    }
    catch (e) {
        if (e instanceof ControllerNotFoundError) {
            Logger.warn(appController + " not found");
        }
        else {
            throw e;
        }
    }
}

/**
 * Event
 */
var Event = /** @class */ (function () {
    function Event() {
    }
    Event.factory = function (events) {
        var factoredEvents = {};
        for (var name_1 in events) {
            var event_1 = events[name_1];
            factoredEvents[name_1] = event_1;
            if (Accessor.isAccessorDefinition(event_1)) {
                var _a = Accessor.getAccessor(event_1), controllerName = _a[0], method = _a[1];
                factoredEvents[name_1] = this.getEventMethod(controllerName, method);
            }
            else if (typeof event_1 !== 'function') {
                factoredEvents[name_1] = function () { throw new InvalidAccessorDefinitionError(); };
            }
        }
        return factoredEvents;
    };
    Event.getEventMethod = function (controllerName, method) {
        var instance = Loader.getInstance(controllerName);
        if (instance[method]) {
            return instance[method].bind(instance);
        }
        return function () { throw new MethodNotFoundError(method, controllerName); };
    };
    Event.get = function (event) {
        if (Accessor.isAccessorDefinition(event)) {
            var _a = Accessor.getAccessor(event), controllerName = _a[0], method = _a[1];
            return this.getEventMethod(controllerName, method);
        }
        return function () { throw new InvalidAccessorDefinitionError(); };
    };
    Event.callEventCycle = function (before, after, events, eventArgs, callback) {
        return __awaiter(this, void 0, void 0, function () {
            var beforeEvent, prevent, afterEvent;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        beforeEvent = events[before];
                        prevent = beforeEvent && beforeEvent(eventArgs) === true;
                        if (!!prevent) return [3 /*break*/, 2];
                        return [4 /*yield*/, callback()];
                    case 1:
                        _a.sent();
                        afterEvent = events[after];
                        if (afterEvent) {
                            afterEvent(eventArgs);
                        }
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    return Event;
}());

/**
 * Class
 */
var Metadata = /** @class */ (function () {
    function Metadata() {
    }
    Metadata.get = function (path, local) {
        return __awaiter(this, void 0, void 0, function () {
            var error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, Http.get(this.getMetadataUrl(path, local))];
                    case 1: return [2 /*return*/, (_a.sent()).data];
                    case 2:
                        error_1 = _a.sent();
                        throw error_1;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Metadata.getMetadataUrl = function (path, local) {
        if (local === void 0) { local = false; }
        return local
            ? "/metadata/" + path + ".json"
            : "" + Config.metadataEndPoint + path;
    };
    Metadata.clearInstance = function (instanceName, instanceId) {
        var instance = this.instances[instanceName];
        if (Array.isArray(instance)) {
            this.instances[instanceName] = instance.filter(function (item) { return (item.componentId !== instanceId); });
            if (this.instances[instanceName].length === 1) {
                this.instances[instanceName] = this.instances[instanceName][0];
            }
        }
        else if (this.instances[instanceName].componentId === instanceId) {
            delete this.instances[instanceName];
        }
    };
    Metadata.addInstance = function (instance) {
        this.instancesCount = this.instancesCount + 1;
        if (this.instances[instance.name]) {
            if (Array.isArray(this.instances[instance.name])) {
                this.instances[instance.name].push(instance);
            }
            else {
                this.instances[instance.name] = [this.instances[instance.name], instance];
            }
        }
        else {
            this.instances[instance.name] = instance;
        }
        return this.instancesCount;
    };
    Metadata.getInstance = function (name) {
        var instance = Array.isArray(this.instances[name])
            ? this.instances[name][0] : this.instances[name];
        if (instance) {
            return instance;
        }
        throw new InstanceNotFoundError(name);
    };
    Metadata.getInstances = function (name) {
        var instance = this.instances[name];
        return Array.isArray(instance) ? instance : [instance];
    };
    Metadata.instances = {};
    Metadata.instancesCount = 0;
    return Metadata;
}());

/**
 * Column Formatter Provider Class
 */
var FormatterParserProvider = /** @class */ (function () {
    function FormatterParserProvider() {
    }
    FormatterParserProvider.registerFormatter = function (name, formatterFunction) {
        this.formatters[name] = formatterFunction;
    };
    FormatterParserProvider.getFormatter = function (name) {
        return this.formatters[name];
    };
    FormatterParserProvider.registerParser = function (name, parserFunction) {
        this.parsers[name] = parserFunction;
    };
    FormatterParserProvider.getParser = function (name) {
        return this.parsers[name];
    };
    FormatterParserProvider.formatters = {};
    FormatterParserProvider.parsers = {};
    return FormatterParserProvider;
}());

/**
 * Class to handle cookies
 */
var Cookie = /** @class */ (function () {
    function Cookie() {
    }
    /**
     * Set a cookie
     * @param name Cookie name
     * @param value Cookie value
     * @param expiresAt Expiration date in miliseconds
     */
    Cookie.setCookie = function (name, value, expiresAt) {
        var date = new Date();
        var expire = expiresAt || 7 * 24 * 60 * 60 * 1000;
        date.setTime(date.getTime() + expire);
        document.cookie = name + "=" + value + "; expires=" + date.toUTCString() + "; path=/";
    };
    /**
     * Retrieve a cookie value
     * @param name Cookie name
     * @returns Cookie value or undefined
     */
    Cookie.getCookie = function (name) {
        var value = "; " + document.cookie;
        var parts = value.split("; " + name + "=");
        if (parts.length === 2) {
            var lastElement = parts.pop();
            return lastElement.split(';').shift();
        }
        return undefined;
    };
    /**
     * Invalidate a cookie
     * @param name Cookie name
     */
    Cookie.deleteCookie = function (name) {
        var date = new Date();
        date.setTime(date.getTime() + (-1 * 24 * 60 * 60 * 1000));
        document.cookie = name + "=; expires=" + date.toUTCString() + "; path=/";
    };
    return Cookie;
}());

/**
 * Base class used to define data sources and perform CRUD methods.
 */
var Datasource = /** @class */ (function () {
    /**
    * Create a Datasource
    * @param datasource Datasource structure
    */
    function Datasource(datasource) {
        /**
         * Current (selected) row
         */
        this.currentRow = {};
        /**
         * Data collection
         */
        this.data = [];
        /**
         * Filter value
         */
        this.filter = {};
        /**
         * Limit value
         */
        this.limit = Config.datasourceLimit || 10;
        /**
         * Defines if the datasource are loading
         */
        this.loading = false;
        /**
         * Order value
         */
        this.order = [];
        /**
         * Page value
         */
        this.page = 1;
        /**
         * Search value
         */
        this.search = '';
        /**
         * Defines which row column should be able to search
         */
        this.searchIn = [];
        /**
         * All selected rows
         */
        this.selectedRows = [];
        /**
         * Number of lines
         */
        this.total = 0;
        /**
         * The column that should be used as unique key
         */
        this.uniqueKey = 'id';
        /**
         * Page selected rows
         */
        this.visibleSelectedRows = [];
        /**
         * Defines if the datasource should watch URL changes for updates
         */
        this.watchUrl = false;
        /**
        * Filter applied flag
        */
        this.filterApplied = '';
        /**
         * Datasource first page
         */
        this.firstPage = 1;
        /**
         * URL reserved keys
         */
        this.reservedKeys = {
            page: true,
            limit: true,
            order: true,
            filter: true,
            in: true,
            search: true,
            search_in: true,
        };
        this.watchUrl = datasource.watchUrl === true;
        this.currentRow = datasource.currentRow || this.currentRow;
        this.defaultLimit = this.limit = datasource.limit || this.limit;
        this.searchIn = datasource.searchIn || this.searchIn;
        this.uniqueKey = datasource.uniqueKey || this.uniqueKey;
        this.filter = datasource.filter || this.filter;
        this.order = datasource.order || this.order;
        this.search = datasource.search || this.search;
        this.page = datasource.page || this.page;
        this.limit = datasource.limit = this.limit;
        this.updateInternalProperties(datasource);
        this.updateUrlQueryString();
    }
    /**
     * Updates all properties affected by URL if the datasource is configured to
     * watch url changes
     * @param datasource Datasource structure
     */
    Datasource.prototype.updateInternalProperties = function (datasource) {
        if (datasource === void 0) { datasource = {}; }
        if (!this.watchUrl)
            return;
        var queryString = URL.getParsedQueryStringFromUrl();
        this.filter = this.getFilter(queryString, datasource.filter);
        this.order = this.getOrder(queryString.order, datasource.order);
        this.search = this.getSearch(queryString.search, datasource.search);
        this.page = this.getPage(queryString.page, datasource.page);
        this.limit = this.getLimit(queryString.limit, datasource.limit);
    };
    /**
     * Retrieves filter value from url and datasource config
     * @param datasource Datasource config
     * @param queryString Query string values
     * @returns Filter value
     */
    Datasource.prototype.getFilter = function (queryString, filter) {
        if (filter === void 0) { filter = {}; }
        this.filterApplied = this.watchUrl && queryString.filter || '';
        var urlFilter = this.getFilterFromUrl(queryString);
        return this.filterApplied ? urlFilter : __assign(__assign({}, filter), urlFilter);
    };
    /**
     * Retrieves filter from url, ignoring reserved keys
     * @param queryString Query string values
     * @returns Filter from url
     */
    Datasource.prototype.getFilterFromUrl = function (queryString) {
        var filter = {};
        for (var key in queryString) {
            if (!this.reservedKeys[key]) {
                filter[key] = queryString[key];
            }
        }
        return filter;
    };
    /**
     * Retrieves order value from url and datasource config
     * @param order Query string order value
     * @param localOrder Datasource order value
     * @returns Order value
     */
    Datasource.prototype.getOrder = function (urlOrder, datasourceOrder) {
        if (datasourceOrder === void 0) { datasourceOrder = []; }
        if (this.watchUrl && urlOrder) {
            return (Array.isArray(urlOrder) ? urlOrder : [urlOrder]);
        }
        return datasourceOrder;
    };
    /**
     * Retrieves search value from url and datasource config
     * @param urlSearch Query string search value
     * @param datasourceSearch Datasource search value
     * @returns Search value
     */
    Datasource.prototype.getSearch = function (urlSearch, datasourceSearch) {
        if (datasourceSearch === void 0) { datasourceSearch = ''; }
        return this.watchUrl && urlSearch || this.search || datasourceSearch;
    };
    /**
     * Retrieves page value from url and datasource config
     * @param urlPage Query string page value
     * @param datasourcePage Datasource page value
     * @returns Page value
     */
    Datasource.prototype.getPage = function (urlPage, datasourcePage) {
        if (this.watchUrl && urlPage) {
            return +urlPage;
        }
        return datasourcePage || this.firstPage;
    };
    /**
     * Retrieves Limit value from url and datasource config
     * @param urlLimit Query string limit value
     * @param datasourceLimit Datasource limit value
     * @returns Limit value
     */
    Datasource.prototype.getLimit = function (urlLimit, datasourceLimit) {
        if (this.watchUrl && urlLimit) {
            return +urlLimit;
        }
        return datasourceLimit || this.defaultLimit;
    };
    /**
     * Updates url query string
     */
    Datasource.prototype.updateUrlQueryString = function () {
        if (this.watchUrl && this.urlHasChanged()) {
            URL.replaceQueryString(this.getQueryStringValues());
        }
    };
    /**
     * Checks if the query string value has changed
     * @returns URL has changed
     */
    Datasource.prototype.urlHasChanged = function () {
        return this.watchUrl && this.getUrlQueryString() !== this.getDatasourceAsQueryString();
    };
    /**
     * Retrieves a query string from datasource values
     * @returns Datasource values as query string
     */
    Datasource.prototype.getDatasourceAsQueryString = function () {
        return URL.getFormattedQueryString(this.getQueryStringValues());
    };
    /**
     * Retrieves an object with all properties that affect the url
     * @returns Query string object value
     */
    Datasource.prototype.getQueryStringValues = function () {
        return __assign({ page: this.page.toString(), limit: this.limit.toString(), order: this.order, search: this.search ? this.search : undefined, filter: this.filterApplied || undefined }, this.filter);
    };
    /**
     * Retrieves current query string with default values
     * @returns Query string with defaults
     */
    Datasource.prototype.getUrlQueryString = function () {
        var query = URL.getParsedQueryStringFromUrl();
        return URL.getFormattedQueryString(__assign({ page: query.page || this.firstPage.toString(), limit: query.limit || this.defaultLimit.toString(), order: query.order || [], search: query.search || undefined, filter: query.filter || undefined }, this.getFilterFromUrl(query)));
    };
    /**
     * Updates search value
     * @param search Search value
     * @returns Promise with data collection
     */
    Datasource.prototype.setSearch = function (search) {
        this.search = search;
        if (this.watchUrl) {
            if (search) {
                URL.updateQueryString({ search: search });
            }
            else {
                var query = URL.getParsedQueryStringFromUrl();
                delete query.search;
                URL.setQueryString(query);
            }
        }
        return this.get();
    };
    /**
     * Adds a new filter position or replace if exists
     * @param column Filter column name
     * @param value Filter value
     * @returns Promise with data collection
     */
    Datasource.prototype.addFilter = function (column, value) {
        if (this.isValidFilterValue(column, value)) {
            this.filter[column] = value;
            return this.updateFilter();
        }
        return this.removeFilter(column);
    };
    /**
     * Removes a filter position
     * @param column Filter column name
     * @returns Promise with data collection
     */
    Datasource.prototype.removeFilter = function (column) {
        delete this.filter[column];
        return this.updateFilter();
    };
    /**
     * Sets new filter value
     * @param filter Filter value
     * @returns Promise with data collection
     */
    Datasource.prototype.setFilter = function (filter) {
        var _this = this;
        this.filter = {};
        Object.keys(filter).forEach(function (column) {
            if (_this.isValidFilterValue(column, filter[column])) {
                _this.filter[column] = filter[column];
            }
            else {
                delete _this.filter[column];
            }
        });
        return this.updateFilter();
    };
    /**
     * Clears filter value
     * @returns Promise with data collection
     */
    Datasource.prototype.clearFilter = function () {
        this.filter = {};
        return this.updateFilter();
    };
    /**
     * Resets page and selected rows and tries to update the url
     * @returns Promise with data collection
     */
    Datasource.prototype.updateFilter = function () {
        return __awaiter(this, void 0, void 0, function () {
            var query, resevedValues, key;
            return __generator(this, function (_a) {
                this.page = this.firstPage;
                this.selectedRows = [];
                this.visibleSelectedRows = [];
                if (this.watchUrl) {
                    this.filterApplied = 'applied';
                    query = URL.getParsedQueryStringFromUrl();
                    resevedValues = {};
                    for (key in query) {
                        if (this.reservedKeys[key]) {
                            resevedValues[key] = query[key];
                            delete query[key];
                        }
                    }
                    resevedValues.page = this.firstPage;
                    URL.setQueryString(__assign(__assign(__assign({}, resevedValues), this.filter), { filter: this.filterApplied }));
                }
                return [2 /*return*/, this.get()];
            });
        });
    };
    /**
     * Checks if a filter value is valid
     * @param value Filter value
     * @returns Is valid filter value
     */
    Datasource.prototype.isValidFilterValue = function (column, value) {
        return !this.reservedKeys[column] && value !== '' && value != null;
    };
    /**
     * Updates datasource limit
     * @param limit Limit value
     * @param replaceUrl Should replace or push url
     * @returns Promise with data collection
     */
    Datasource.prototype.setLimit = function (limit, replaceUrl) {
        if (replaceUrl === void 0) { replaceUrl = false; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.limit = limit;
                if (this.watchUrl) {
                    URL.updateQueryString({ limit: limit }, replaceUrl);
                }
                return [2 /*return*/, this.reloadAndUpdateSelectedRows()];
            });
        });
    };
    /**
     * Updates datasource page
     * @param page Page value
     * @param replaceUrl Should replace or push url
     * @returns Promise with data collection
     */
    Datasource.prototype.setPage = function (page, replaceUrl) {
        if (replaceUrl === void 0) { replaceUrl = false; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.page = page;
                if (this.watchUrl) {
                    URL.updateQueryString({ page: page }, replaceUrl);
                }
                return [2 /*return*/, this.reloadAndUpdateSelectedRows()];
            });
        });
    };
    /**
     * Adds or updates an order for specific column
     * @param column Order column name
     * @param value Order value
     * @returns Promise with data collection
     */
    Datasource.prototype.addOrder = function (column, value) {
        var parsedValue = column + "." + value;
        var index = this.findOrderIndex(column);
        if (index !== -1) {
            this.order[index] = parsedValue;
        }
        else {
            this.order.push(parsedValue);
        }
        return this.updateOrder();
    };
    /**
     * Removes an order for specific column
     * @param column Order column name
     * @returns Promise with data collection
     */
    Datasource.prototype.removeOrder = function (column) {
        var index = this.findOrderIndex(column);
        if (index !== -1) {
            this.order.splice(index, 1);
        }
        return this.updateOrder();
    };
    /**
     * Sets new order value
     * @param order Order values
     * @returns Promise with data collection
     */
    Datasource.prototype.setOrder = function (order) {
        this.order = order;
        return this.updateOrder();
    };
    /**
     * Clears order value
     * @returns Promise with data collection
     */
    Datasource.prototype.clearOrder = function () {
        this.order = [];
        return this.updateOrder();
    };
    /**
     * Updates order on query string
     * @returns Promise with data collection
     */
    Datasource.prototype.updateOrder = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (this.watchUrl) {
                    URL.updateQueryString({ order: this.order });
                }
                return [2 /*return*/, this.reloadAndUpdateSelectedRows()];
            });
        });
    };
    /**
     * Updates selected rows, fetches and retrieves data collection
     * @returns Promise with data collection
     */
    Datasource.prototype.reloadAndUpdateSelectedRows = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.get()];
                    case 1:
                        response = _a.sent();
                        this.updateVisibleSelectedRows();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    /**
     * Retrieve the current sort for a column
     * @param column Column name
     * @returns Column order or null
     */
    Datasource.prototype.getOrderByColumn = function (column) {
        var index = this.findOrderIndex(column);
        return index !== -1 ? this.order[index].split('.')[1] : null;
    };
    /**
     * Retrieves column index of order collection
     * @param column Columns name
     * @returns Column index
     */
    Datasource.prototype.findOrderIndex = function (column) {
        return this.order.findIndex(function (order) {
            return order.split('.')[0] === column;
        });
    };
    /**
     * Selects a row
     * @param row Datasource row
     */
    Datasource.prototype.selectRow = function (row) {
        var index = this.selectedRowIndex(this.selectedRows, row);
        if (index === -1) {
            this.selectedRows.push(row);
            this.updateVisibleSelectedRows();
        }
    };
    /**
     * Deselects a row
     * @param row Datasource row
     */
    Datasource.prototype.deselectRow = function (row) {
        this.removeSelectedRow(this.selectedRows, row);
        this.removeSelectedRow(this.visibleSelectedRows, row);
    };
    /**
     * Removes a row from selected rows collection
     * @param selectedRows Selected rows collection
     * @param row Row to remove
     */
    Datasource.prototype.removeSelectedRow = function (selectedRows, row) {
        var index = this.selectedRowIndex(selectedRows, row);
        if (index !== -1) {
            selectedRows.splice(index, 1);
        }
    };
    /**
     * Retrieves row index from selected rows collection
     * @param selectedRows Selected rows collection
     * @param row Datasource row
     */
    Datasource.prototype.selectedRowIndex = function (selectedRows, row) {
        var _this = this;
        return selectedRows.findIndex(function (selected) { return selected[_this.uniqueKey] === row[_this.uniqueKey]; });
    };
    /**
     * Updates visible selected rows collection based on data collection
     */
    Datasource.prototype.updateVisibleSelectedRows = function () {
        var _this = this;
        this.visibleSelectedRows = [];
        this.selectedRows.forEach(function (selectedRow) {
            _this.visibleSelectedRows = _this.data.filter(function (row) {
                return selectedRow[_this.uniqueKey] === row[_this.uniqueKey];
            }).concat(_this.visibleSelectedRows);
        });
    };
    return Datasource;
}());

/**
 * Base class to perform CRUD methods using HTTP requests.
 */
var RestDatasource = /** @class */ (function (_super) {
    __extends(RestDatasource, _super);
    /**
     * Creates a new Rest Datasource
     * @param datasource Datasource structure
     */
    function RestDatasource(datasource) {
        var _this = _super.call(this, datasource) || this;
        /**
         * HTTP route used on CRUD requests
         */
        _this.route = '';
        /**
         * Defines if should execute GET method when Datasource is created
         */
        _this.lazyLoad = true;
        _this.route = datasource.route || _this.route;
        _this.lazyLoad = datasource.lazyLoad !== false;
        if (!_this.lazyLoad) {
            _this.get();
        }
        return _this;
    }
    /**
     * Retrieves a promise with data value ordered by order value
     * and filtered by search, filter, limit and page
     * @return Promise with data value
     * @throws Will throws if request fail
     */
    RestDatasource.prototype.get = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        this.error = undefined;
                        this.loading = true;
                        return [4 /*yield*/, this.find(this.getRequestParams())];
                    case 1:
                        response = (_a.sent()).data;
                        this.loading = false;
                        if (Array.isArray(response.data)) {
                            return [2 /*return*/, this.updateAndRetrieveCollection(response)];
                        }
                        return [2 /*return*/, this.updateAndRetrieveRow(response)];
                    case 2:
                        e_1 = _a.sent();
                        this.error = e_1;
                        this.loading = false;
                        throw e_1;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Calls http request and retrieves http response
     * @param params Datasource params
     */
    RestDatasource.prototype.find = function (params) {
        return Http.get(this.route, {
            params: params,
            paramsSerializer: function (params) {
                return qs.stringify(params, { arrayFormat: 'repeat' });
            },
        });
    };
    /**
     * Retrieves request params
     */
    RestDatasource.prototype.getRequestParams = function () {
        this.updateInternalProperties();
        return __assign({ page: this.page, limit: this.limit, order: this.order, search: this.search || undefined, search_in: this.search ? this.searchIn : [], in: Object.keys(this.filter) }, this.filter);
    };
    /**
     * Updates and retrieves datasource current row
     * @param response Http response
     * @returns Row
     */
    RestDatasource.prototype.updateAndRetrieveRow = function (response) {
        this.currentRow = response.data;
        return this.currentRow;
    };
    /**
     * Updates and retrieves datasource data collection
     * @param response Http response
     * @returns Data collection
     */
    RestDatasource.prototype.updateAndRetrieveCollection = function (response) {
        return __awaiter(this, void 0, void 0, function () {
            var pagination, lastPage;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        pagination = response.pagination;
                        this.page = pagination.page;
                        this.limit = pagination.limit;
                        this.total = pagination.total;
                        this.data = response.data;
                        lastPage = Math.ceil(this.total / this.limit);
                        if (lastPage && lastPage < this.page) {
                            return [2 /*return*/, this.setPage(lastPage, true)];
                        }
                        return [4 /*yield*/, this.data];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Adds a new row to datasource based on route
     * @param row Row to create
     * @returns HTTP response
     */
    RestDatasource.prototype.post = function (row) {
        return Http.post(this.route, row);
    };
    /**
     * Updates a datasource row based on route
     * @param row Row to update
     * @returns HTTP Response
     */
    RestDatasource.prototype.put = function (row) {
        return Http.put(row.uri, row);
    };
    /**
     * Deletes a datasource row uri
     * @param row Row to delete
     * @returns HTTP Response
     */
    RestDatasource.prototype.delete = function (row) {
        return Http.delete(row.uri);
    };
    return RestDatasource;
}(Datasource));

/**
 * Base class to perform CRUD methods using data stored in memory.
 */
var MemoryDatasource = /** @class */ (function (_super) {
    __extends(MemoryDatasource, _super);
    /**
     * Creates a new Memory Datasource
     * @param datasource Datasource structure
     */
    function MemoryDatasource(datasource) {
        var _this = _super.call(this, datasource) || this;
        /**
         * All memory data
         */
        _this.allData = [];
        /**
         * Filtered data
         */
        _this.filteredData = [];
        /**
         * Order types
         */
        _this.orderTypes = {
            asc: 1,
            desc: -1,
            same: 0,
        };
        _this.allData = datasource.data || _this.allData;
        _this.get();
        return _this;
    }
    /**
     * Retrieves a promise with data value ordered by order value
     * and filtered by search, filter, limit and page
     * @returns Promise with data value
     */
    MemoryDatasource.prototype.get = function () {
        return __awaiter(this, void 0, void 0, function () {
            var end, start, lastPage;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.updateInternalProperties();
                        this.updateFilteredData();
                        this.sortFilteredData();
                        end = this.limit === -1 ? this.allData.length : this.limit * this.page;
                        start = this.limit === -1 ? 0 : end - this.limit;
                        this.data = this.filteredData.slice(start, end);
                        this.total = this.filteredData.length;
                        lastPage = Math.ceil(this.total / this.limit);
                        if (!(lastPage && lastPage < this.page)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.setPage(lastPage, true)];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2: return [4 /*yield*/, this.data];
                    case 3: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Updates filtered data
     */
    MemoryDatasource.prototype.updateFilteredData = function () {
        var _this = this;
        this.filteredData = Object.keys(this.filter).length
            ? this.allData.filter(function (row) { return _this.getRowByFilter(row); })
            : Array.from(this.allData);
        this.filteredData = this.search
            ? this.filteredData.filter(function (row) { return _this.getRowBySearch(row); })
            : this.filteredData;
    };
    /**
     * Checks if row passed on current filter
     * @param row Each datasource row
     * @returns Row passed
     */
    MemoryDatasource.prototype.getRowByFilter = function (row) {
        var filtered = false;
        for (var key in this.filter) {
            if (row[key] && row[key].toString().indexOf(this.filter[key]) !== -1) {
                filtered = true;
            }
            else {
                filtered = false;
                break;
            }
        }
        return filtered;
    };
    /**
     * Checks if row passed on current search
     * @param row Each datasource row
     * @returns Row passed
     */
    MemoryDatasource.prototype.getRowBySearch = function (row) {
        var filtered = false;
        for (var key in row) {
            if (this.searchIn.indexOf(key) !== -1 && row[key].toString().indexOf(this.search) !== -1) {
                filtered = true;
                break;
            }
            else {
                filtered = false;
            }
        }
        return filtered;
    };
    /**
     * Reorder filtered data based on order value
     */
    MemoryDatasource.prototype.sortFilteredData = function () {
        var columns = [];
        var order = [];
        this.order.forEach(function (value) {
            var splitted = value.split('.');
            columns.push(splitted[0]);
            order.push(splitted[1]);
        });
        this.sortArray(this.filteredData, columns, order);
    };
    /**
     * Adds a new row to datasource
     * @param row Row to create
     * @returns Promise with added row
     */
    MemoryDatasource.prototype.post = function (row) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.allData = this.allData.concat(row);
                        return [4 /*yield*/, row];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Updates a datasource row using unique key
     * @param row Row to update
     * @returns Promise with updated row
     * @throws Will throw if row doesn't exists
     */
    MemoryDatasource.prototype.put = function (row) {
        return __awaiter(this, void 0, void 0, function () {
            var index;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        index = this.allData.findIndex(function (dataRow) { return dataRow[_this.uniqueKey] === row[_this.uniqueKey]; });
                        if (!(index !== -1)) return [3 /*break*/, 2];
                        this.allData[index] = row;
                        return [4 /*yield*/, row];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2: throw new Error("Row with id " + row[this.uniqueKey] + " not found");
                }
            });
        });
    };
    /**
     * Deletes a datasource row using unique key
     * @param row Row to delete
     * @returns Promise with deleted row
     * @throws Will throw if row doesn't exists
     */
    MemoryDatasource.prototype.delete = function (row) {
        return __awaiter(this, void 0, void 0, function () {
            var index;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        index = this.allData.findIndex(function (dataRow) { return dataRow[_this.uniqueKey] === row[_this.uniqueKey]; });
                        if (!(index !== -1)) return [3 /*break*/, 2];
                        this.allData.splice(index, 1);
                        return [4 /*yield*/, row];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2: return [2 /*return*/, Promise.reject(new Error("Row with id " + row[this.uniqueKey] + " not found"))];
                }
            });
        });
    };
    /**
     * Sorts the data collection using the same principles of ordering in databases
     * @param array Data collection
     * @param columns Columns used to oreder the collection
     * @param types Order orientation. All values must be asc or desc
     */
    MemoryDatasource.prototype.sortArray = function (collection, columns, types) {
        var _this = this;
        collection.sort(function (row, nextRow) { return _this.sort(row, nextRow, columns, types); });
    };
    /**
     * Custom sort for collections
     * @param row Collection row
     * @param nextRow Next row from collection
     * @param columns Columns used to oreder the collection
     * @param types Order orientation. All values must be asc or desc
     * @param index Columns and types position
     * @returns Row's position
     */
    MemoryDatasource.prototype.sort = function (row, nextRow, columns, types, index) {
        if (index === void 0) { index = 0; }
        if (row[columns[index]] === nextRow[columns[index]]) {
            var nextIndex = index + 1;
            if (columns.hasOwnProperty(nextIndex)) {
                return this.sort(row, nextRow, columns, types, nextIndex);
            }
            return this.orderTypes.same;
        }
        if (row[columns[index]] > nextRow[columns[index]]) {
            return this.orderTypes[types[index]];
        }
        return this.orderTypes[types[index]] * -1;
    };
    return MemoryDatasource;
}(Datasource));

/**
 * Datasource that stores simple data in memory.
 */
var SimpleDatasource = /** @class */ (function (_super) {
    __extends(SimpleDatasource, _super);
    /* istanbul ignore next */
    /**
     * Creates a new Memory Datasource
     * @param datasource Datasource structure
     */
    function SimpleDatasource(datasource) {
        var _this = _super.call(this, datasource) || this;
        _this.items = datasource.items;
        _this.allData = _this.data;
        _this.get();
        return _this;
    }
    Object.defineProperty(SimpleDatasource.prototype, "items", {
        get: function () {
            return this.data.map(function (item) {
                return item.value;
            });
        },
        set: function (items) {
            this.data = (items || []).map(function (item) {
                return { value: item };
            });
        },
        enumerable: true,
        configurable: true
    });
    return SimpleDatasource;
}(MemoryDatasource));

/**
 * Base class used to factory datasource based on type
 */
var DatasourceFactory = /** @class */ (function () {
    function DatasourceFactory() {
    }
    DatasourceFactory.factory = function (datasource) {
        if (datasource === void 0) { datasource = {}; }
        var config = __assign({ type: 'memory' }, datasource);
        if (this.types[config.type]) {
            return new (this.types[config.type])(config);
        }
        throw new Error("Datasource " + datasource.type + " not registered");
    };
    DatasourceFactory.register = function (type, classReference) {
        this.types[type] = classReference;
    };
    DatasourceFactory.types = {
        rest: RestDatasource,
        memory: MemoryDatasource,
        simple: SimpleDatasource,
    };
    return DatasourceFactory;
}());

export { Accessor, Config, ControllerNotFoundError, Cookie, Datasource, DatasourceFactory, Event, FormatterParserProvider, Http, I18n, InstanceNotFoundError, Interceptor, InvalidAccessorDefinitionError, Loader, Logger, Mask, MemoryDatasource, Messages, Metadata, MethodNotFoundError, RestDatasource, Router, SimpleDatasource, Singleton, URL, Validation, init };
